// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"12173f59","256":"4bb82a8a"}[chunkId] + ".chunk.css";
};